<template>
  <svg width = "100%" height = "100%" id="chartOverflow" ref="chartOverflow">
    <Grid/>
  </svg>
</template>

<script>
import Grid from '@/components/layout/pressure_flow_chart/pressure_flow_chart_components/Grid';

export default {
  components: {
    Grid
  },
};
</script>